import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationsService } from './logic/translations.service';
import { TranslationsLogicService } from './logic/translations/translations-logic.service';
import { TranslationDaoService } from './dao/translation-dao.service';
import { TranslationStorageDaoService } from './dao/translation-storage-dao/translation-storage-dao.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    {
      provide: TranslationsService,
      useClass: TranslationsLogicService,
    },
    {
      provide: TranslationDaoService,
      useClass: TranslationStorageDaoService,
    },
  ],
})
export class TranslationsModule {}
